import isEmpty from "lodash/isEmpty";

// Capitalize the first letter of a passed in string
export const capitalize = (s) => {
  return s && s[0].toUpperCase() + s.slice(1);
};

export const isUrl = (str) => {
  if (typeof str !== "string") {
    return false;
  }

  try {
    const url = new URL(str);

    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const countCharacter = (s, char) => {
  if (isEmpty(s)) {
    return 0;
  }
  return s.split(char).length - 1;
};

export const generateRandomId = (length = 12) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};
